import Img1 from "../images/coins/bitcoin_coin.svg";
import Img2 from "../images/coins/ethirum_coin.svg";
import Img3 from "../images/coins/solana_coin.svg";
import Img4 from "../images/coins/ripple_coin.svg";
import Img5 from "../images/coins/solanas_coin.svg";
import Img6 from "../images/coins/tether_coin.svg";
import Img7 from "../images/coins/usd_coin.svg";
import Img8 from "../images/coins/cardano_coin.svg";
export const coins = [
    { id: 1, name: "Bitcoin", symbol: "BTC", img: Img1 },
    { id: 2, name: "Ethereum", symbol: "ETH", img: Img2 },
    { id: 3, name: "Solana", symbol: "SOL", img: Img3 },
    { id: 4, name: "Ripple", symbol: "XRP", img: Img4 },
    { id: 5, name: "Solana", symbol: "SOL", img: Img5 },
    { id: 6, name: "Tether ", symbol: "USDT", img: Img6 },
    { id: 7, name: "USD Coin", symbol: "USDC ", img: Img7 },
    { id: 8, name: "Cardano", symbol: "ADA", img: Img8 },
  
  ];

  